const getUniqueProviders = (arr: CarData[]) => {
  const uniqueProviders: string[] = [];
  const provAgencies: { provider: Provider; agency: Agency }[] = [];

  for (const item of arr) {
    for (const provider of item.providers) {
      if (!uniqueProviders.includes(provider.providerCode)) {
        uniqueProviders.push(provider.providerCode);
        provAgencies.push({ provider: provider, agency: item.agency });
      }
    }
  }

  return provAgencies;
};

const getUniqueAgencies = (arr: CarData[]) => {
  const uniqueAgencies: string[] = [];
  const provAgencies: { provider: Provider; agency: Agency }[] = [];

  for (const item of arr) {
    for (const provider of item.providers) {
      if (!uniqueAgencies.includes(item.agency.name)) {
        uniqueAgencies.push(item.agency.name);
        provAgencies.push({ provider: provider, agency: item.agency });
      }
    }
  }

  return provAgencies;
};

const getUniqueLocations = (arr: CarData[]) => {
  const uniqueLocations: string[] = [];
  const provAgencies: { provider: Provider; agency: Agency }[] = [];

  for (const item of arr) {
    for (const provider of item.providers) {
      if (!uniqueLocations.includes(item.agency.pickupLocation.address)) {
        uniqueLocations.push(item.agency.pickupLocation.address);
        provAgencies.push({ provider: provider, agency: item.agency });
      }
    }
  }

  return provAgencies;
};

const getUniqueData = (arr: CarData[]) => {
  const uniqueLocations: string[] = [];
  const uniqueProviders: string[] = [];
  const uniqueAgencies: string[] = [];
  const provAgencies: { provider: Provider; agency: Agency }[] = [];

  for (const item of arr) {
    for (const provider of item.providers) {
      if (
        !uniqueLocations.includes(item.agency.pickupLocation.address) ||
        !uniqueProviders.includes(provider.providerCode) ||
        !uniqueAgencies.includes(item.agency.name)
      ) {
        uniqueAgencies.push(item.agency.name);
        uniqueProviders.push(provider.providerCode);
        uniqueLocations.push(item.agency.pickupLocation.address);
        provAgencies.push({ provider: provider, agency: item.agency });
      }
    }
  }

  return provAgencies;
};

const getUniqueCarClasses = (arr:CarData[]) => {
  const uniqueClasses:string[] = [];
  for(const item of arr) {
    if(!uniqueClasses.includes(item.car.carclass)){
      uniqueClasses.push(item.car.carclass)
    }
  }
  return uniqueClasses
}

export {
  getUniqueProviders,
  getUniqueAgencies,
  getUniqueLocations,
  getUniqueData,
  getUniqueCarClasses
};
